import { LinkedRelationshipFormModel_MX } from './formModel';

export const getInitialValues = (): LinkedRelationshipFormModel_MX => {
  return {
    majorityInCompanies: undefined,
    majorityInCompaniesCompanyName: '',
    partnerOfCompanies: undefined,
    partnerOfCompaniesCompanyName: '',
    customerOfVwfs: undefined,
    contactNumberOrVehicleRegistrationNumber: '',
  };
};
